// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { PaginationStyle } from "@conklin/MobiusOverrides/Pagination";
import { columnsStyles } from "@conklin/Overrides/Widgets/ProductList/ProductListColumns";
import { color, xScreen } from "@conklin/XDL/Utilities";
import { FormInputWrapper } from "@insite/mobius/FormField";
import { IconWrapper } from "@insite/mobius/Icon";
import X from "@insite/mobius/Icons/X";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

columnsStyles.container = {
    css: css`
        display: grid;
        ${xScreen("gt", "xl")} {
            grid-template-columns: minmax(0, 375px) 1fr;
        }
        grid-template-columns: minmax(0, 317px) 1fr;
        gap: 22px;
        ${xScreen("lte", "md")} {
            grid-template-columns: minmax(0, 1fr);
        }
    `,
};

columnsStyles.titleContainer = {
    css: css`
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding-bottom: 16px;
        flex: 1;
        background: ${color("common.black")};
    `,
};

columnsStyles.title = {
    forwardAs: "p",
    size: 16,
    weight: "bold",
    color: "common.white",
    lineHeight: "24px",
    css: css`
        letter-spacing: 0;
        margin: 0;
    `,
};

columnsStyles.closeBtn = {
    color: "common.black",
    icon: {
        iconProps: {
            src: X,
            size: 16,
            css: css`
                opacity: 0.66;
            `,
        },
    },
    css: css`
        ${IconWrapper} {
            margin: 0;
        }
    `,
};

columnsStyles.buttonsWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        position: sticky;
        bottom: 0;
        background: ${color("common.white")};
        border-top: 1px solid ${color("common.border")};
        padding: 17px 0;
    `,
};

columnsStyles.drawer = {
    closeButtonIconProps: {
        size: 20,
        css: css`
            &&& {
                color: ${color("common.white")};
            }
        `,
    },
    cssOverrides: {
        drawerTitle: css`
            border: none;
            background: ${color("common.black")};
            padding: 16px;
            padding-bottom: 0px;
            ${TypographyStyle} {
                line-height: 19px;
            }
        `,

        drawerBody: css`
            width: 360px;
            ${xScreen("lte", "sm")} {
                top: 0;
                height: 100%;
                width: 100%;
            }
        `,
        drawerContent: css`
            overflow-x: hidden;
            padding: 12px 16px 0 16px;
            background: ${color("common.white")};
            height: 100%;
        `,
        titleButton: css`
            top: 20px;
        `,
    },
};

columnsStyles.cancelBtn = {
    variant: "secondary",
    css: css`
        width: fit-content;
    `,
};
columnsStyles.applyBtn = {
    variant: "primary",
    css: css`
        width: fit-content;
    `,
};

columnsStyles.controlsWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
        gap: 17px;
        & div {
            max-width: fit-content;
            width: 100%;
        }
        ${PaginationStyle} {
            margin: 0;
            background-color: ${color("common.white")};
            border-radius: unset;
            padding: 0;
            > span[class^="PerPageSelect"] {
                margin: 0;
                ${FormInputWrapper} {
                    ${xScreen("lte", "md")} {
                        min-width: 70px !important;
                    }
                }
            }
        }
        padding-bottom: 16px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};

columnsStyles.leftColumnGridItem = {
    css: css`
        grid-column: 1 / 2;
        grid-row: 1 / 2;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

columnsStyles.extraCards = {
    css: css`
        grid-column: 1 / 2;
        grid-row: 2 / 3;
        padding-top: 12px;
        ${xScreen("lte", "md")} {
            padding-top: 0;
            grid-row: 4 / 5;
            > div:not(:empty) {
                max-width: 50%;
            }
        }
        ${xScreen("lte", "sm")} {
            > div:not(:empty) {
                max-width: 100%;
            }
        }
    `,
};

columnsStyles.rightColumnGridItem = {
    css: css`
        grid-column: 2/ 3;
        grid-row: 1 / 4;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 2;
        }
    `,
};
